import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts'
import { InstallBanner } from '../ui'

/**
 * What a signed-out visitor sees on a member page.
 *
 * Lifted out of Layout, which used to return this inline. It lives on its own
 * now so that RequireAuth can decide who sees it, instead of every page
 * carrying the decision by virtue of rendering a Layout.
 */
export function LoginGate() {
  const { authError, signInWithDiscord } = useAuth()

  return (
    <div className="min-h-screen bg-raven-darker flex items-center justify-center p-4">
      <InstallBanner />
      <div className="text-center max-w-md w-full">
        <img
          src="/raven-logo.png"
          alt="Raven Guild"
          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-4 sm:mb-6 rounded-full object-cover"
        />
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-100 mb-2">Raven Guild</h1>
        <p className="text-gray-400 mb-6 sm:mb-8 text-sm sm:text-base">
          Login with Discord to access guild tools and raid management.
        </p>

        {authError && (
          <div className="bg-red-500/20 border border-red-500/50 rounded px-4 py-3 text-red-400 mb-6">
            {authError}
          </div>
        )}

        <button
          onClick={() => signInWithDiscord()}
          className="bg-[#5865F2] hover:bg-[#4752C4] px-6 py-3 rounded-lg text-white transition-colors flex items-center gap-3 mx-auto text-lg"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z" />
          </svg>
          Login with Discord
        </button>

        <p className="text-gray-500 text-sm mt-6">
          You must be a member of the Raven Discord server to access this site.
        </p>

        <p className="text-gray-600 text-sm mt-8">
          Not in the guild?{' '}
          <Link to="/" className="text-gray-400 hover:text-gray-200 underline">
            Read about Raven
          </Link>
        </p>
      </div>
    </div>
  )
}
